/* globals Croppie */

const PICTURE_UPLOAD_LOADED = 'PictureUploadLoaded';
const PICTURE_UPLOAD_REMOVED = 'PictureUploadRemoved';
const SAVE_FORM_CLICKED = 'SaveFormClicked';
const CROPPED_IMAGE_URL = 'CroppedImageUrl';
const KEY = 'engagecore-Key';

/**
 *  Initialize a picture upload drop zone
 * @param {string} domId The drop zone dom id
 * @param {(dataUrl: string) => void} onUpload An onUpload handler
 */
export function initializePictureUploadDropZone(domId, onUpload) {
	const dropZone = document.getElementById(domId);
	const fileInputBtn = dropZone.querySelector('input[type=file]');

	['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
		dropZone.addEventListener(
			eventName,
			(event) => {
				event.preventDefault();
				event.stopPropagation();
			},
			false,
		);
	});

	/**
	 * @param {Array} files The array of files
	 */
	function readFiles(files) {
		let index = 0;
		const fileObjects = [];
		const reader = new FileReader();

		/**
		 * Read one file
		 */
		function readOne() {
			const file = files[index];
			if (file) {
				reader.readAsDataURL(file);
			} else {
				if (fileObjects.length > 0) {
					let filesEvent;
					try {
						filesEvent = new CustomEvent('files', {
							detail: fileObjects,
						});
					} catch {
						filesEvent = document.createEvent('CustomEvent');
						filesEvent.initCustomEvent(
							'files',
							false,
							false,
							fileObjects,
						);
					}
					dropZone.dispatchEvent(filesEvent);
				}
			}
		}
		reader.onload = function onLoad() {
			const result = {
				lastModified: files[index].lastModified,
				name: files[index].name,
				size: files[index].size,
				mimeType: files[index].type,
				dataURL: reader.result,
			};

			if (onUpload) {
				onUpload(reader.result);
			}

			fileObjects.push(result);
			index++;
			readOne();
		};
		readOne();
	}

	dropZone.addEventListener(
		'drop',
		(event) => {
			event.preventDefault();
			event.stopPropagation();
			const files = event.dataTransfer.files;
			readFiles(files);
		},
		false,
	);

	fileInputBtn.addEventListener('change', () => {
		const files = fileInputBtn.files;
		readFiles(files);
	});

	return {
		reset: () => {
			fileInputBtn.value = '';
		},
	};
}

/**
 *
 * @param elmApp
 */
export function initPorts(elmApp) {
	let croppie;

	/**
	 * @param {string} domId The dom Id
	 * @param {string} dataUrl The data url
	 */
	function initCroppie(domId, dataUrl) {
		const otps = {
			showZoomer: false,
			viewport: { width: 250, height: 250 },
			// boundary: {
			// 	width: 250,
			// 	height: 250,
			// },
		};
		croppie = new Croppie(document.getElementById(domId), otps);

		croppie.bind({ url: dataUrl, zoom: 0 });
	}

	/**
	 * @param {string} key The key
	 * @param {object} value The value
	 */
	function sendSub(key, value) {
		elmApp.ports.sub.send({ [KEY]: key, value });
	}

	let onFileRemoved = () => {
		//
	};

	elmApp.ports.out.subscribe((json) => {
		switch (json[KEY]) {
			case PICTURE_UPLOAD_LOADED:
				{
					const { domId, imageUrl } = json.value;

					const { reset } = initializePictureUploadDropZone(
						domId,
						(dataUrl) => {
							initCroppie(domId, dataUrl);
						},
					);

					if (imageUrl) {
						initCroppie(domId, imageUrl);
					}

					onFileRemoved = () => {
						croppie?.destroy();
						reset();
					};
				}
				break;
			case PICTURE_UPLOAD_REMOVED:
				onFileRemoved();
				break;
			case SAVE_FORM_CLICKED:
				try {
					croppie
						.result({ type: 'base64', size: 'viewport' })
						.then((dataUrl) => {
							sendSub(CROPPED_IMAGE_URL, {
								url: dataUrl,
								completedMsg: json.value,
							});
						});
				} catch {
					sendSub(CROPPED_IMAGE_URL, {
						url: '',
						completedMsg: json.value,
					});
				}
				break;
			default:
				break;
		}
	});
}
